import {Card, CardActionArea, css, Stack, styled} from '@mui/material';
import Icon from 'presentation/icons';
import {StyledCardProps} from './types';

const StyledCardActionArea = styled(CardActionArea)`
	width: 100%;

	height: 72px;
	border-radius: 8px;

	${({theme}) => theme.breakpoints.down('sm')} {
		height: 52px;
	}
`;

const StyledCard = styled(Card)<StyledCardProps>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;
	height: 100%;

	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 8px 12px;
	}

	${({isEnabled}) =>
		isEnabled &&
		css`
			${({theme}) => theme.breakpoints.down('sm')} {
				padding: 0;
				border: none;
			}
		`}
`;

const StyledStack = styled(Stack)<StyledCardProps>`
	flex-direction: row;
	align-items: center;
	gap: 12px;

	font-size: 13px;

	font-weight: 600;
	line-height: 1.5;
	letter-spacing: 0.46px;

	${({theme}) => theme.breakpoints.down('sm')} {
		font-size: 12px;
		gap: 8px;
	}

	${({isEnabled}) =>
		isEnabled &&
		css`
			${({theme}) => theme.breakpoints.down('sm')} {
				font-size: 14px;
				gap: 16px;
			}
		`}
`;

const StyledIconButtonContainer = styled('div')`
	display: flex;
	align-items: center;
	margin-left: 8px;
`;

const StyledIcon = styled(Icon)`
	color: ${({theme}) => theme.palette.primary.main};

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 17px;
		height: 17px;
	}
`;

const StyledImageIcon = styled('img')`
	width: 24px;
	height: auto;
	flex-shrink: 0;

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 17px;
	}
`;

export {
	StyledCardActionArea,
	StyledCard,
	StyledStack,
	StyledIconButtonContainer,
	StyledIcon,
	StyledImageIcon,
};
